import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Redirect to /login on 401 for authenticated calls
let redirecting = false;
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    // Don't redirect on public endpoints or the auth/me probe
    const isPublic = url.includes("/public/") || url.includes("/auth/me") || url.includes("/auth/login") || url.includes("/auth/register");
    if (err?.response?.status === 401 && !isPublic && !redirecting) {
      redirecting = true;
      setTimeout(() => {
        try {
          if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/register")) {
            window.location.href = "/login";
          }
        } finally {
          setTimeout(() => { redirecting = false; }, 500);
        }
      }, 0);
    }
    return Promise.reject(err);
  }
);

export function getWsUrl(auctionId) {
  const url = new URL(BACKEND_URL);
  const proto = url.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${url.host}/api/ws/${auctionId}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function statusColor(status) {
  return {
    upcoming: "text-blue-400 bg-blue-500/10 border-blue-500/30",
    live: "text-emerald-400 bg-emerald-500/10 border-emerald-500/30",
    completed: "text-zinc-400 bg-zinc-800 border-zinc-700",
    cancelled: "text-red-400 bg-red-500/10 border-red-500/30",
    draft: "text-amber-400 bg-amber-500/10 border-amber-500/30",
  }[status] || "text-zinc-400 bg-zinc-800 border-zinc-700";
}
